import { required, numeric, requiredIf, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

const recipeItemRules = {
  quantity_system: {
    required: helpers.withMessage(i18n.global.t('Please enter a quantity system.'), required),
    numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity system.'), numeric)
  },
  quantity_display: {
    required: helpers.withMessage(i18n.global.t('Please enter a quantity display.'), required),
    numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity display.'), numeric),
    maxValue: helpers.withMessage(
      i18n.global.t('Display quantity must not exceed system quantity.'),
      (value, sibling) => !helpers.req(value) || +value <= +sibling.quantity_system
    )
  },
  condition: {
    required
  }
};

export default function (formState) {
  return {
    form: {
      cost_estimate: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      is_config: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      variants: {
        required: helpers.withMessage(i18n.global.t('Please add at least one variant.'), requiredIf(formState.is_config == true)),
      },
      recipes: {
        required: helpers.withMessage(i18n.global.t('Please add at least one recipe.'), requiredIf(formState.is_config == false)),
      },
    }
  }
};
